/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SetPlayerRouteImport } from './routes/set-player'
import { Route as SetLocationRouteImport } from './routes/set-location'
import { Route as ObserveGameRouteImport } from './routes/observe-game'
import { Route as NoGameRouteImport } from './routes/no-game'
import { Route as GameEndedRouteImport } from './routes/game-ended'
import { Route as GameRouteImport } from './routes/game'
import { Route as IndexRouteImport } from './routes/index'

const SetPlayerRoute = SetPlayerRouteImport.update({
  id: '/set-player',
  path: '/set-player',
  getParentRoute: () => rootRouteImport,
} as any)
const SetLocationRoute = SetLocationRouteImport.update({
  id: '/set-location',
  path: '/set-location',
  getParentRoute: () => rootRouteImport,
} as any)
const ObserveGameRoute = ObserveGameRouteImport.update({
  id: '/observe-game',
  path: '/observe-game',
  getParentRoute: () => rootRouteImport,
} as any)
const NoGameRoute = NoGameRouteImport.update({
  id: '/no-game',
  path: '/no-game',
  getParentRoute: () => rootRouteImport,
} as any)
const GameEndedRoute = GameEndedRouteImport.update({
  id: '/game-ended',
  path: '/game-ended',
  getParentRoute: () => rootRouteImport,
} as any)
const GameRoute = GameRouteImport.update({
  id: '/game',
  path: '/game',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/game': typeof GameRoute
  '/game-ended': typeof GameEndedRoute
  '/no-game': typeof NoGameRoute
  '/observe-game': typeof ObserveGameRoute
  '/set-location': typeof SetLocationRoute
  '/set-player': typeof SetPlayerRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/game': typeof GameRoute
  '/game-ended': typeof GameEndedRoute
  '/no-game': typeof NoGameRoute
  '/observe-game': typeof ObserveGameRoute
  '/set-location': typeof SetLocationRoute
  '/set-player': typeof SetPlayerRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/game': typeof GameRoute
  '/game-ended': typeof GameEndedRoute
  '/no-game': typeof NoGameRoute
  '/observe-game': typeof ObserveGameRoute
  '/set-location': typeof SetLocationRoute
  '/set-player': typeof SetPlayerRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/game'
    | '/game-ended'
    | '/no-game'
    | '/observe-game'
    | '/set-location'
    | '/set-player'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/game'
    | '/game-ended'
    | '/no-game'
    | '/observe-game'
    | '/set-location'
    | '/set-player'
  id:
    | '__root__'
    | '/'
    | '/game'
    | '/game-ended'
    | '/no-game'
    | '/observe-game'
    | '/set-location'
    | '/set-player'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  GameRoute: typeof GameRoute
  GameEndedRoute: typeof GameEndedRoute
  NoGameRoute: typeof NoGameRoute
  ObserveGameRoute: typeof ObserveGameRoute
  SetLocationRoute: typeof SetLocationRoute
  SetPlayerRoute: typeof SetPlayerRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/set-player': {
      id: '/set-player'
      path: '/set-player'
      fullPath: '/set-player'
      preLoaderRoute: typeof SetPlayerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/set-location': {
      id: '/set-location'
      path: '/set-location'
      fullPath: '/set-location'
      preLoaderRoute: typeof SetLocationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/observe-game': {
      id: '/observe-game'
      path: '/observe-game'
      fullPath: '/observe-game'
      preLoaderRoute: typeof ObserveGameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/no-game': {
      id: '/no-game'
      path: '/no-game'
      fullPath: '/no-game'
      preLoaderRoute: typeof NoGameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/game-ended': {
      id: '/game-ended'
      path: '/game-ended'
      fullPath: '/game-ended'
      preLoaderRoute: typeof GameEndedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/game': {
      id: '/game'
      path: '/game'
      fullPath: '/game'
      preLoaderRoute: typeof GameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  GameRoute: GameRoute,
  GameEndedRoute: GameEndedRoute,
  NoGameRoute: NoGameRoute,
  ObserveGameRoute: ObserveGameRoute,
  SetLocationRoute: SetLocationRoute,
  SetPlayerRoute: SetPlayerRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
